import type { MailboxInfo } from 'owa-client-types';
import { LicenseType } from 'owa-copilot-settings-store/lib/services/types/serviceSettingTypes';
import copilotSettingsStore from 'owa-copilot-settings-store/lib/store/store';
import hasM365CopilotLicense from './hasM365CopilotLicense';

export function isProdigiUser(mailboxInfo: MailboxInfo): boolean {
    const store = copilotSettingsStore(mailboxInfo);
    if (store.isEnabled) {
        return (
            store.licenses.some(license => license === LicenseType.M365ConsumerCredits) &&
            !hasM365CopilotLicense(mailboxInfo)
        );
    }

    return false;
}

export default isProdigiUser;
